// src/components/user/controltower/TowerHeader.jsx
import React from 'react';
import { ChevronLeft, Menu, X, Zap } from 'lucide-react';

export function TowerHeader({ setActiveComponent, showList, onToggleList, deliveryPoints, expressPoints }) {
  function count(arr, status) {
    return arr.filter(d => d.status === status).length;
  }

  const pills = [
    { label: 'Pendiente', value: count(deliveryPoints, 'pending'),   color: 'bg-orange-100 text-orange-700' },
    { label: 'En Camino', value: count(deliveryPoints, 'encamino'),  color: 'bg-blue-100 text-blue-700'   },
    { label: 'Entregado', value: count(deliveryPoints, 'entregado'), color: 'bg-green-100 text-green-700' },
  ];

  const expressPills = [
    { label: '⚡ Pending',   value: count(expressPoints, 'pending'),   color: 'bg-brand-green/10 text-brand-green' },
    { label: '⚡ En Camino', value: count(expressPoints, 'encamino'),  color: 'bg-brand-green/20 text-brand-green' },
    { label: '⚡ Entregado', value: count(expressPoints, 'entregado'), color: 'bg-brand-green/30 text-brand-green' },
  ];

  return (
    <div className="flex-shrink-0 bg-white border-b border-slate-200 shadow-sm z-30">
      <div className="px-4 py-3">
        {/* Top row */}
        <div className="flex items-center justify-between mb-3">
          <button
            onClick={() => setActiveComponent('Options')}
            className="flex items-center gap-2 text-slate-700 hover:text-brand-primary transition-colors font-montserrat"
          >
            <ChevronLeft className="w-5 h-5" />
            <span className="text-sm">Volver</span>
          </button>

          <h1 className="text-lg font-extrabold text-brand-primary font-montserrat italic">
            Torre de Control
          </h1>

          <button
            onClick={onToggleList}
            className="p-2 text-brand-primary hover:bg-brand-primary/10 rounded-lg transition-colors lg:hidden"
          >
            {showList ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
          <div className="w-20 hidden lg:block" />
        </div>

        {/* Counter pills row */}
        <div className="flex flex-wrap gap-1.5">
          {/* Regular pills */}
          {pills.map(p => p.value > 0 && (
            <span key={p.label} className={`text-xs font-semibold font-montserrat px-2 py-0.5 rounded-full ${p.color}`}>
              {p.label}: {p.value}
            </span>
          ))}

          {/* Divider if both types exist */}
          {expressPoints.length > 0 && deliveryPoints.length > 0 && (
            <span className="text-slate-300 text-xs self-center">|</span>
          )}

          {/* Express pills */}
          {expressPoints.length > 0 && expressPills.map(p => p.value > 0 && (
            <span key={p.label} className={`text-xs font-semibold font-montserrat px-2 py-0.5 rounded-full ${p.color}`}>
              {p.label}: {p.value}
            </span>
          ))}

          {/* Totals */}
          <span className="ml-auto text-xs font-bold text-slate-500 font-montserrat self-center">
            {deliveryPoints.length} regular · {expressPoints.length} express
          </span>
        </div>
      </div>
    </div>
  );
}